<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('culvert.title')"/>
        <div class="col-sm-12 nopads my-2">
          <culvert-search @search="fetchCulverts"/>
          <culvert-list class="my-2" :culverts="results" @row-clicked="rowClicked"/>
      <Transition name="fade">
        <culvert-details
          v-if="item"
          :item="item"
          :set-inspection-params="setInspectionParams"
          @close="item = null"
        />
      </Transition>
      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </div>
  </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {mapHelper} from "@/components/mixins/MapMixin";
import CulvertDetails from "@/components/culvert/CulvertDetails";
import CulvertList from "@/components/culvert/CulvertList";
import CulvertSearch from "@/components/culvert/CulvertSearch";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'Culverts',
    components: {Navbar, CulvertSearch, CulvertList, CulvertDetails},
    mixins: [restApi, mapHelper],
    props: {
        setInspectionParams: {
            type: Function,
            default: null
        }
    },

    data: function () {
        return {
            results: [],
            loading: false,
            lastSearchedParams: null,
            mapVisible: false,
            item: null,
            mapHelper
        }
    },

    methods: {
        fetchCulverts: function (params) {
            this.loading = true
            this.mapVisible = false
            this.lastSearchedParams = params
            this.results = []
            this.restFetchParams(this.culvertUrl, this.lastSearchedParams, this.handleSearch, () => {
                this.loading = false
            })
        },
        handleSearch: function (response) {
            this.results = response.data
            this.loading = false
        },
        rowClicked: function (item) {
            this.item = item
        }
    }
}
</script>
